// extracted by mini-css-extract-plugin
module.exports = {"root":"_27ecd49","disableSelect":"_6587260"};